'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _lodash = require('lodash');

var _NumberInputControl = require('./NumberInputControl');

var _NumberInputControl2 = _interopRequireDefault(_NumberInputControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var NumberInputControls = function NumberInputControls(_ref) {
	var _ref$incrementText = _ref.incrementText;
	var incrementText = _ref$incrementText === undefined ? '▲' : _ref$incrementText;
	var _ref$decrementText = _ref.decrementText;
	var decrementText = _ref$decrementText === undefined ? '▼' : _ref$decrementText;
	var _ref$incrementTitle = _ref.incrementTitle;
	var incrementTitle = _ref$incrementTitle === undefined ? 'Increment' : _ref$incrementTitle;
	var _ref$decrementTitle = _ref.decrementTitle;
	var decrementTitle = _ref$decrementTitle === undefined ? 'Decrement' : _ref$decrementTitle;
	var _ref$onIncrement = _ref.onIncrement;
	var onIncrement = _ref$onIncrement === undefined ? _lodash.noop : _ref$onIncrement;
	var _ref$onDecrement = _ref.onDecrement;
	var onDecrement = _ref$onDecrement === undefined ? _lodash.noop : _ref$onDecrement;
	return _react2.default.createElement(
		'div',
		{ className: 'rea11y-NumberInputControls' },
		_react2.default.createElement(_NumberInputControl2.default, {
			name: 'increment',
			text: incrementText,
			title: incrementTitle,
			onClick: onIncrement
		}),
		_react2.default.createElement(_NumberInputControl2.default, {
			name: 'decrement',
			text: decrementText,
			title: decrementTitle,
			onClick: onDecrement
		})
	);
};

NumberInputControls.propTypes = {
	incrementText: _react.PropTypes.string,
	decrementText: _react.PropTypes.string,
	incrementTitle: _react.PropTypes.string,
	decrementTitle: _react.PropTypes.string,
	onIncrement: _react.PropTypes.func,
	onDecrement: _react.PropTypes.func
};

exports.default = (0, _recompose.pure)(NumberInputControls);